/* eslint-disable */
import os from './os'
import { 
    webchatShare,
    qqShare,
    weiboShare,
    qqyinShare,
    kuwoShare,
    kugouShare,
    shareWebchatWeb,
    shareSinaWeb,
    shareQQWeb,
    shareQQzoneWeb,
    shareUcbrower,
    shareQQbrower
} from './index'

export default (infos, type) => {
    // 微信端内
    if (os.isWeixin) {
        webchatShare(infos)
        return
    }
    // qq端内
    if (os.isQQ) {
        qqShare(infos)
        return
    }
    // 微博端内
    // if (os.isWeibo) {
    //     weiboShare(infos)
    //     return
    // }
    // qq音乐
    if (os.isQQMusic) {
        qqyinShare(infos)
        return
    }
    // 酷我音乐
    if (os.isKuwoMusic) {
        kuwoShare(infos)
        return
    }
    // 酷狗音乐
    if (os.isKuGouMusic) {
        kugouShare(infos)
        return
    }
    // UC浏览器
    if (os.isUCbrower) {
        shareUcbrower(infos)
        return
    }
    // QQ浏览器
    if (os.isQQbrower) {
        shareQQbrower(infos)
        return
    }

    // 弹出通用分享
    // if(!infos.router){
    //     store.commit('showCommonShare')
    // }
    // 网页分享
    switch (type) {
        case 'webchat':
        case 'webchat_pyq':
            shareWebchatWeb(infos)
            break;
        case 'qq':
            shareQQWeb(infos)
            break;
        case 'qq_zone':
            shareQQzoneWeb(infos)
            break;
        case 'sina':
            shareSinaWeb(infos)
            break;
    }
}